
import useMessage, { EMessageType } from '@/hooks/useMessage'
import { ELoginStatus } from '@/store/user';
import { IUser } from 'login';
import vue from 'vue'
import { mapGetters } from 'vuex';
const { showMessage } = useMessage()
export default vue.extend({
	data() {
		return {
			formData: {
				nickname: "",
				content: "",
			},
			error: {
				nickname: "",
				content: "",
			},
			isSubmiting: false,
		}
	},
	methods: {
		handleSubmit() {
			if (this.loginStatus === ELoginStatus.unlogin) {
				showMessage({
					message: 'you need login',
					type: EMessageType.error,
					duration: 2000,
					dom: this.$refs.form as HTMLElement,
				})
				return
			}
			this.error.nickname = this.formData.nickname ? "" : "content is empty";
			this.error.content = this.formData.content ? "" : "content is empty";
			if (this.error.nickname || this.error.content) {
				// 有错误
				return;
			}
			this.isSubmiting = true; // 正在提交，防止重复点击
			this.$emit("submit", this.formData, (successMsg: string) => {
				showMessage({
					message: successMsg,
					type: EMessageType.success,
					duration: 1000,
					dom: this.$refs.form as HTMLElement,
					callback: () => {
						this.isSubmiting = false;
						this.formData.nickname = "";
						this.formData.content = "";
					},
				});
			}); // 让父组件来处理事件
		},
	},
	computed: {
		...mapGetters({
			loginStatus: 'userStore/loginStatus',
			user: 'userStore/user'
		}) as {
			loginStatus: () => ELoginStatus,
			user: () => IUser
		},
		nickNameComputed(): string {
			if (this.loginStatus === ELoginStatus.logined) {
				return this.user.name
			} else {
				return null
			}
		},
	},
	watch: {
		nickNameComputed: {
			handler(n) {
				// console.log(n);
				this.formData.nickname = n

			},
			immediate: true
		}
	}
});
